module.exports = __webpack_public_path__ + "static/img/book15.9dd0536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book15.jpg
// module id = fz5y
// module chunks = 1